import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import type { Visualize3dObject } from '@magicore/visualize-3d';
import { HoodlineData } from '../models/hoodline-data.model';

@Injectable({
  providedIn: 'root'
})
export class ProductEntityService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get the Visualize3D Object for the given hood
   * @param hoodId The id of the hood to fetch
   * @param view The viewpoint to use (affects dimension lines)
   */
  getHoodModel(hoodId: string, view?: string): Observable<Visualize3dObject> {
    const flags: string[] = [view === undefined ? 'Top' : view, 'Hood', 'DimensionLine']; // default view is Top, always show hood and dimension lines
    return this.httpClient
      .post<Visualize3dObject>(`${environment.apiUrl}/hood/3d`, {
        HoodId: hoodId,
        Flags: flags
      })
      .pipe(take(1));
  }

  /**
   * Get the Visualize3D Object for the given hood line preview
   * @param hoodId The id of the hood to fetch
   * @param view The viewpoint to use (affects dimension lines)
   */
  getHoodLinePreviewModel(hoodId: string, view?: string): Observable<HoodlineData> {
    const flags: string[] = [view === undefined ? 'Top' : view, 'Hood', 'HoodLine', 'DimensionLine']; // default view is Top, always show hood line and dimension lines
    return this.httpClient
      .post<HoodlineData>(`${environment.apiUrl}/hood/3d-line`, {
        HoodId: hoodId,
        Flags: flags
      })
      .pipe(take(1));
  }
}
